module.exports = __webpack_public_path__ + "img/bg_avatar_male_65.b94c49f6.png";